import { default as fetch, baseURL, timeout } from "../utils/fetch";
import axios from "axios";

/**
 * 獲取plan 列表
 * http://schedulepost.dev.apphi.com/api/docs/#!/plans/Plans_list
 * @returns {*}
 */
export function list() {
  return fetch.get("plans");
}

/**
 * 获取用户所在城市
 * @returns {*}
 */
export function getCurrentCountry() {
  return axios.get(`${baseURL}/ipinfo`, {
    timeout,
  });
}



// WEBPACK FOOTER //
// ./src/apis/plan.js